import { TextContainer } from '@shopify/polaris'

const Instructions = () => <TextContainer>
  <div className="title" style={{ fontSize: '28px', fontWeight: 600, lineHeight: '32px' }}>Choose period for the test</div>
  <p> Set the timeframe during which you’d like to run your test. You can set exact dates and times or start it right now if you’d like.</p>
</TextContainer>

export default Instructions
